import { render, staticRenderFns } from "./OpportunityEditor.vue?vue&type=template&id=ddcc504e&scoped=true"
import script from "./OpportunityEditor.vue?vue&type=script&lang=js"
export * from "./OpportunityEditor.vue?vue&type=script&lang=js"
import style0 from "./OpportunityEditor.vue?vue&type=style&index=0&id=ddcc504e&prod&scoped=true&lang=css"
import style1 from "./OpportunityEditor.vue?vue&type=style&index=1&id=ddcc504e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcc504e",
  null
  
)

export default component.exports